import Cookies from 'js-cookie';
import JWTDecode from 'jwt-decode';

const AUTH_KEY = 'YFY_KEY';
const COMPANY_KEY = 'YFY_COMPANY';
const PATH = '/';

const DOMAIN = process.env.REACT_APP_DOMAIN;

class AuthHelper {
  static setToken(data) {
    const token = data.access_token;
    const expires = data.expires;

    const user = data.user || {};
    const company = user.company || {};

    this.setCompany(company.id);
    this.setCookie(AUTH_KEY, window.btoa(token), { expires: new Date(expires) });
  }

  static setCookie(key, value, options) {
    const cookieOptions = {
      path: PATH,
      domain: DOMAIN,
      ...options,
    };

    return Cookies.set(key, value, cookieOptions);
  }

  static getToken() {
    const auth_token = Cookies.get(AUTH_KEY);

    if (auth_token) {
      return window.atob(auth_token);
    }

    return null;
  }

  static getCompany() {
    const session_data = this.getSession();
    const selected_company = Cookies.get(COMPANY_KEY) || localStorage.getItem(COMPANY_KEY);
    return selected_company || session_data.company;
  }

  static setCompany(company_id) {
    if (this.getCompany() !== company_id) {
      this.setCookie(COMPANY_KEY, company_id, { expires: new Date(2147483647 * 1000) });
      window.dispatchEvent(new Event('COMPANY:CHANGE'));
    }
  }

  static getSession() {
    const token = this.getToken();

    if (token) {
      return JWTDecode(token);
    }

    return {};
  }

  static clearToken() {
    const options = { path: PATH, domain: DOMAIN };
    Cookies.remove(AUTH_KEY, options);
    Cookies.remove(COMPANY_KEY, options);
    localStorage.removeItem(COMPANY_KEY);
  }
}

export default AuthHelper;
